<template>
  <div>
    <!-- 新規登録ポップアップ -->
    <v-dialog v-model="createDialog" max-width="450px">
      <v-card>
        <v-card-title>配信種別選択</v-card-title>
        <v-card-text>
          <p>新規作成する配信の種別を選択してください。</p>
          <v-row>
            <v-col>
              <v-btn
                v-if="hasEditAuth('LI')"
                class="mx-2"
                color="primary"
                style="width: 100%"
                @click="moveLalertNotification"
                >お知らせ</v-btn
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn
                v-if="hasEditAuth('LE')"
                class="mx-2"
                color="primary"
                style="width: 100%"
                @click="moveLalertEvacuation"
                >避難情報</v-btn
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <span v-if="hasEditAuth('LE')"
                >避難情報を新規に発令する場合は<br />
                発令中の避難情報が無いことを確認してください。<br />
                >既に発令済みの避難情報がある場合は<br />
                一覧から「続報」を選択して配信してください。</span
              ><br />
            </v-col>
          </v-row>
          <v-card-actions>
            <v-row>
              <v-spacer></v-spacer>
              <v-btn class="mx-2" color="primary" @click="createDialog = false"
                >キャンセル</v-btn
              >
            </v-row>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- メイン画面 -->
    <v-sheet elevation="1">
      <v-toolbar dense color="white">
        <v-toolbar-title>{{ screenTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          v-if="!listFlag"
          class="mx-2"
          color="primary"
          @click="createItem()"
        >
          「新規登録」はこのボタンを押してください
        </v-btn>
      </v-toolbar>
      <v-container fluid>
        <error-message :error-object="errorObject" />
        <success-message :success-object="successObject" />
        <p style="margin: 5px 0 15px 0">
          Lアラートは下の表を参照してください。検索条件を指定することで一覧から絞り込むことができます。
        </p>
        <v-row>
          <!-- TODO 1行目 -->
          <v-col cols="3">
            <v-text-field
              v-model="deliveryNoFilterValue"
              label="配信番号"
              :placeholder="config.PLACEHOLDER_INPUT"
              outlined
              clearable
              append-icon="mdi-magnify"
            >
            </v-text-field>
          </v-col>
          <v-col cols="3">
            <v-select
              v-model="deliveryCaFilterValue"
              :items="selectList[0]"
              :placeholder="config.PLACEHOLDER_SELECT"
              label="配信種別"
              clearable
              outlined
            >
            </v-select>
          </v-col>
          <v-col cols="3">
            <v-select
              v-model="declareFlgFilterValue"
              :items="selectList[1]"
              :placeholder="config.PLACEHOLDER_SELECT"
              label="発令・解除区分"
              clearable
              outlined
            >
            </v-select>
          </v-col>
          <v-col cols="3">
            <v-select
              v-model="declareClsFilterValue"
              :items="selectList[2]"
              :placeholder="config.PLACEHOLDER_SELECT"
              label="発令区分"
              clearable
              outlined
            >
            </v-select>
          </v-col>
        </v-row>
        <!-- 2行目 -->
        <v-row>
          <v-col cols="5">
            <datetime-picker
              :title="'配信日時（開始）'"
              :without-now="true"
              :max="deliveryEndDateValue"
              :selectedDatetime.sync="deliveryStartDateValue"
              :isDisplayTime="false"
              class="datetime-without-min"
            />
          </v-col>
          <v-col cols="5">
            <datetime-picker
              :title="'配信日時（終了）'"
              :without-now="true"
              :min="deliveryStartDateValue"
              :selectedDatetime.sync="deliveryEndDateValue"
              :isDisplayTime="false"
              class="datetime-without-min"
            />
          </v-col>
        </v-row>
        <!-- 3行目 -->
        <v-row>
          <v-col cols="3">
            <v-select
              v-model="disasterNameFilterValue"
              :items="disasters"
              :placeholder="config.PLACEHOLDER_SELECT"
              label="災害名称"
              item-text="disaster_name"
              item-value="disaster_no"
              clearable
              outlined
            >
            </v-select>
          </v-col>
          <v-col cols="3">
            <v-select
              v-model="emergencyClassFilterValue"
              :items="emergencyClass"
              :placeholder="config.PLACEHOLDER_SELECT"
              label="緊急事態区分"
              item-text="name"
              item-value="emergencyClass"
              clearable
              outlined
            >
              <template v-slot:selection="data">
                {{ emergencyClassItems(data.item) }}
              </template>
              <template v-slot:item="data">
                {{ emergencyClassItems(data.item) }}
              </template>
            </v-select>
          </v-col>
        </v-row>
        <!-- 4行目 -->
        <v-row>
          <v-col cols="5">
            <datetime-picker
              :title="'公開希望終了日時（開始）'"
              :without-now="true"
              :max="publishEndDateValue"
              :selectedDatetime.sync="publishStartDateValue"
              :isDisplayTime="false"
              class="datetime-without-min"
            />
          </v-col>
          <v-col cols="5">
            <datetime-picker
              :title="'公開希望終了日時（終了）'"
              :without-now="true"
              :min="publishStartDateValue"
              :selectedDatetime.sync="publishEndDateValue"
              :isDisplayTime="false"
              class="datetime-without-min"
            />
          </v-col>
        </v-row>
        <!-- 5行目 -->
        <v-row>
          <v-col cols="3">
            <v-select
              v-model="deliveryStatusFilterValue"
              :items="selectList[3]"
              :placeholder="config.PLACEHOLDER_SELECT"
              label="配信状況"
              multiple
              clearable
              outlined
            >
            </v-select>
          </v-col>
          <v-col cols="3">
            <v-select
              v-model="deliveryClsFilterValue"
              :items="selectList[4]"
              :placeholder="config.PLACEHOLDER_SELECT"
              label="配信区分"
              multiple
              clearable
              outlined
            >
            </v-select>
          </v-col>
        </v-row>
        <v-divider class="mb-1" />
      </v-container>
      <!-- TABLE -->
      <top-operation-data-table
        :headers="headers"
        :items="lalertEvaInfoList"
        :sort-by="['delivery_no']"
        :sort-desc="true"
        ref="lalertEvaInfoTable"
        class="fixedWidth"
        disp-mode="nowrap"
        locale="ja-jp"
        loading-text="読込中"
        must-sort
      >
        <!-- 配信日時 -->
        <template v-slot:[`item.delivery_date`]="{ item }">
          {{ formatDatetime(item.delivery_date) }}
        </template>
        <!-- 希望公開日終了日時 -->
        <template v-slot:[`item.publish_end_date`]="{ item }">
          {{ formatDatetime(item.publish_end_date) }}
        </template>
        <!-- 配信種別 -->
        <template v-slot:[`item.delivery_ca`]="{ item }">
          <template v-if="item.delivery_ca === 'LI'">お知らせ</template>
          <template v-if="item.delivery_ca === 'LE'">避難情報</template>
        </template>
        <!-- 発令解除区分 -->
        <template v-slot:[`item.declare_flg`]="{ item }">
          <template v-if="item.declare_flg === '0'">発令</template>
          <template v-if="item.declare_flg === '9'">解除</template>
        </template>
        <!-- 発令区分 -->
        <template v-slot:[`item.declare_cls`]="{ item }">
          <template v-if="item.declare_cls === '3'">高齢者等避難</template>
          <template v-if="item.declare_cls === '4'">避難指示</template>
          <template v-if="item.declare_cls === '6'">警戒区域情報</template>
          <template v-if="item.declare_cls === '5'">緊急安全確保</template>
        </template>
        <!-- 緊急事態区分 -->
        <template v-slot:[`item.emerg_cls`]="{ item }">
          <template v-if="item.emerg_cls === 'NL'"></template>
          <template v-if="item.emerg_cls === 'AL'">ＡＬ：警戒事態</template>
          <template v-if="item.emerg_cls === 'SE'">
            ＳＥ：施設敷地緊急事態
          </template>
          <template v-if="item.emerg_cls === 'GE'">
            ＧＥ：全面緊急事態
          </template>
          <template v-if="item.emerg_cls === 'FN'"> 終結 </template>
        </template>
        <!-- 配信状況 -->
        <template v-slot:[`item.delivery_status`]="{ item }">
          <template v-if="item.delivery_status === '0'">未配信</template>
          <template v-if="item.delivery_status === '1'">配信中</template>
          <template v-if="item.delivery_status === '2'">配信済み</template>
          <template v-if="item.delivery_status === '3'">
            <!-- 配信状況のTOOLTIP(配信失敗のみ市町村表示) -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                  class="d-inline-block text-truncate"
                  style="max-width: 720px"
                >
                  配信失敗
                </span>
              </template>
              <span>{{ addToolTipDeliveryStatus(item) }}</span>
            </v-tooltip>
          </template>
        </template>
        <!-- 配信区分 -->
        <template v-slot:[`item.delivery_cls`]="{ item }">
          <template v-if="item.delivery_cls === 'NE'">新規広報</template>
          <template v-if="item.delivery_cls === 'FU'">続報</template>
          <template v-if="item.delivery_cls === 'CO'">訂正報</template>
          <template v-if="item.delivery_cls === 'CA'">取消報</template>
        </template>
        <!-- 件名のTOOLTIP -->
        <template v-slot:[`item.delivery_title`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="d-inline-block text-truncate"
                style="max-width: 720px"
              >
                {{ item.delivery_title }}
              </span>
            </template>
            <span>{{ item.delivery_title }}</span>
          </v-tooltip>
        </template>
        <!-- 本文のTOOLTIP -->
        <template v-slot:[`item.lalert_message`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="d-inline-block text-truncate"
                style="max-width: 720px"
              >
                {{ item.lalert_message }}
              </span>
            </template>
            <span>{{ item.lalert_message }}</span>
          </v-tooltip>
        </template>
        <!-- 操作ボタン -->
        <template v-slot:[`item.actions`]="{ item }">
          <!-- 画面参照権限のみ -->
          <div v-if="listFlag">
            <v-btn small class="mx-2" color="primary" @click="viewItem(item)">
              参照
            </v-btn>
          </div>
          <!-- 画面編集権限持ち -->
          <div v-else>
            <v-btn
              small
              class="mx-2"
              color="primary"
              @click="editItem(item)"
              v-if="
                item.delivery_status == '0' && hasUpdateAuthorityByItem(item)
              "
            >
              編集
            </v-btn>
            <v-btn
              small
              class="mx-2"
              color="primary"
              @click="resendItem(item)"
              v-if="
                item.delivery_status == '3' && hasUpdateAuthorityByItem(item)
              "
            >
              再送信
            </v-btn>
            <v-btn small class="mx-2" color="primary" @click="viewItem(item)">
              参照
            </v-btn>
            <v-btn
              small
              class="mx-2"
              color="primary"
              @click="deleteItem(item)"
              v-if="
                item.delivery_status == '0' && hasDeleteAuthorityByItem(item)
              "
            >
              削除
            </v-btn>
          </div>
        </template>
        <!-- 配信管理ボタン -->
        <template v-slot:[`item.deliveryActions`]="{ item }">
          <!-- 画面参照権限のみ -->
          <div>
            <v-btn
              small
              class="mx-2"
              color="primary"
              @click="changeStatusItem(item, 'FU')"
              :disabled="checkDeliveryBtn(item)"
            >
              続報
            </v-btn>
            <v-btn
              small
              class="mx-2"
              color="primary"
              @click="changeStatusItem(item, 'CO')"
              :disabled="checkDeliveryBtn(item)"
            >
              訂正報
            </v-btn>
            <v-btn
              small
              class="mx-2"
              color="primary"
              @click="changeStatusItem(item, 'CA')"
              :disabled="checkDeliveryBtn(item)"
            >
              取消報
            </v-btn>
          </div>
        </template>
      </top-operation-data-table>
      <!-- 最新情報取得ボタン -->
      <v-row>
        <v-col cols="12">
          <div class="d-flex">
            <v-btn color="primary" @click="reload"> 最新の情報に更新 </v-btn>
            <div class="mt-2 ml-1 caption">※最新の情報に更新します。</div>
          </div>
        </v-col>
      </v-row>
    </v-sheet>
    <!-- Confirmダイアログ -->
    <confirm-dialog ref="confirm" />
    <!-- OVERLAY -->
    <v-overlay :value="overlay" opacity="1" color="white">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import Vue from "vue";
import Disaster from "@/plugins/disaster";
import messageUtils from "@/mixins/message-utils";
import config from "@/js/const";
import cloneDeep from "lodash/cloneDeep";
import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import { DisasterTranslator } from "@/js/translators/disasterTranslator";
import { ScreenId } from "@/js/value-objects/screen-id";
import { ScreenCrud } from "@/js/value-objects/screen-crud";
import { EmergencyClass } from "@/js/value-objects/emergency-class";

const disasterInfoRepository = RepositoryFactory.get("disasterInfo"); // L災害情報のレポジトリー取得
const lalertEvaInfoRepository = RepositoryFactory.get("lalertEvaInfo"); // L-alert一覧のレポジトリー取得
const allAreaRepository = RepositoryFactory.get("allArea"); // 市町村情報のレポジトリー取得

Vue.use(Disaster);
export default {
  mixins: [messageUtils],
  components: {
    DatetimePicker: () => import("@/components/DatetimePicker"),
    ConfirmDialog: () => import("@/components/ConfirmDialog"),
    ErrorMessage: () => import("@/components/ErrorMessage"),
    SuccessMessage: () => import("@/components/SuccessMessage"),
    TopOperationDataTable: () => import("@/components/ui/TopOperationDataTable")
  },
  data: () => ({
    screenId: ScreenId.SF2101, // 画面ID
    config: config,
    overlay: false,
    dialog: false,
    listFlag: false, // 参照・編集画面区分
    createDialog: false, // 新規登録ポップアップ表示有無
    lalertEvaInfoList: [], // L-alertの一覧情報
    disasters: [], // 災害情報
    municipalities: [], // 市町村情報
    emergencyClass: EmergencyClass.listAll(),
    selectList: cloneDeep(WHICH_CHOOSE), // セレクトボックスに使われる選択項目リスト
    deliveryNoFilterValue: "", // 配信番号(フィルター)
    deliveryCaFilterValue: "", // 配信種別(フィルター)
    declareFlgFilterValue: "", // 発令解除区分(フィルター)
    declareClsFilterValue: "", // 発令区分(フィルター)
    deliveryStartDateValue: "", // 配信開始日時（フィルター）
    deliveryEndDateValue: "", // 配信終了日時（フィルター）
    publishStartDateValue: "", // 希望公開終了日時（フィルター）
    publishEndDateValue: "", // 希望公開終了日時（フィルター）
    disasterNameFilterValue: "", // 災害名称（フィルター）
    emergencyClassFilterValue: "", // 緊急事態区分（フィルター）
    deliveryStatusFilterValue: "", // 配信状況（フィルター）
    deliveryClsFilterValue: "" // 配信区分（フィルター）
  }),

  mounted() {
    this.pageTitle(this.screenTitle);
  },

  created() {
    this.initialize();
  },

  computed: {
    screenTitle() {
      if (this.listFlag) {
        return ScreenId.getScreenTitle(this.screenId) + "（参照）";
      } else {
        return ScreenId.getScreenTitle(this.screenId) + "（登録・編集・削除）";
      }
    },

    headers() {
      return [
        {
          text: "災害ID",
          value: "disaster_no",
          align: " d-none",
          filter: this.disasterNameFilter
        },
        {
          text: "配信番号",
          value: "delivery_no",
          filter: this.deliveryNoFilter
        },
        {
          text: "配信種別",
          value: "delivery_ca",
          filter: this.deliveryCaFilter
        },
        {
          text: "発令・解除区分",
          value: "declare_flg",
          sort: this.emptyStringSorter,
          filter: this.declareFlgFilter
        },
        {
          text: "発令区分",
          value: "declare_cls",
          filter: this.declareClsFilter
        },
        {
          text: "配信日時",
          value: "delivery_date",
          filter: this.deliveryDateFilter
        },
        {
          text: "災害名称",
          value: "disaster_name"
        },
        {
          text: "緊急事態区分",
          value: "emerg_cls",
          filter: this.emergencyClassFilter,
          sort: this.emergencyClassSorter
        },
        {
          text: "希望公開終了日時",
          value: "publish_end_date",
          filter: this.publishDateFilter
        },
        {
          text: "配信状況",
          value: "delivery_status",
          filter: this.deliveryStatusFilter
        },
        {
          text: "配信区分",
          value: "delivery_cls",
          filter: this.deliveryClsFilter
        },
        {
          text: "件名",
          value: "delivery_title"
        },
        {
          text: "本文／避難行動指針",
          value: "lalert_message"
        },
        {
          text: "操作",
          value: "actions",
          sortable: false
        },
        {
          text: "配信管理",
          value: "deliveryActions",
          sortable: false
        }
      ];
    }
  },

  watch: {
    $route: "initialize"
  },

  methods: {
    async initialize() {
      this.overlay = true;
      // 画面操作権限取得
      const data = this.$screenAuthority.find(auth => {
        const screenCrud = ScreenCrud.factory(auth.screen_crud);
        return auth.screen_id === this.screenId && screenCrud.isOperation();
      });

      // 画面の権限チェック
      if (!data) {
        // 参照権限のみの場合
        this.listFlag = true;
      }

      await Promise.all([
        // 災害情報
        disasterInfoRepository.list(this.screenId),
        // LAlert 一覧
        lalertEvaInfoRepository.list(this.screenId),
        // 市町村一覧
        allAreaRepository.getAllArea()
      ])
        .then(values => {
          // 災害情報取得
          this.disasters = DisasterTranslator.sortByDisasterNo(
            values[0].data.results,
            true
          );

          // LAlertの一覧取得
          this.lalertEvaInfoList = this.changeDeliveryNoArrayFormat(
            values[1].data.results
          );

          // 市町村情報取得
          this.municipalities = values[2].data.results[0].municipalities.filter(
            m => m.disp_flg !== "1"
          );

          // 災害名称セレクトボックスの初期値設定
          this.disasterNameFilterValue = this.$disaster.disaster_no;
        })
        .catch(e => {
          this.handleError(e, this.screenId, "aggregation-menu");
        });

      this.overlay = false;
    },

    // 新規登録ボタン押下時、ポップアップを開く
    createItem() {
      this.createDialog = true;
    },

    // Lアラート登録・編集（お知らせ）
    moveLalertNotification() {
      this.$router.push({
        name: "lalert-notification-create"
      });
    },

    // Lアラート登録・編集（避難情報）移動
    moveLalertEvacuation() {
      this.$router.push({
        name: "lalert-evacuation-create"
      });
    },

    // 編集ボタン押下時
    editItem(item) {
      // お知らせ
      if (item.delivery_ca === "LI") {
        this.$router.push({
          name: "lalert-notification-edit",
          params: {
            delivery_no: item.delivery_no
          }
        });
      }
      // 避難情報
      if (item.delivery_ca === "LE") {
        this.$router.push({
          name: "lalert-evacuation-edit",
          params: {
            delivery_no: item.delivery_no
          }
        });
      }
    },

    // 続報・訂正・取消ボタン押下時
    changeStatusItem(item, status) {
      // お知らせ
      if (item.delivery_ca === "LI") {
        this.$router.push({
          name: "lalert-notification-edit",
          params: {
            delivery_no: item.delivery_no,
            delivery_cls: status
          }
        });
      }
      // 避難情報
      if (item.delivery_ca === "LE") {
        this.$router.push({
          name: "lalert-evacuation-edit",
          params: {
            delivery_no: item.delivery_no,
            delivery_cls: status
          }
        });
      }
    },

    // 参照ボタン押下時
    viewItem(item) {
      // お知らせ
      if (item.delivery_ca === "LI") {
        this.$router.push({
          name: "lalert-notification-view",
          params: {
            delivery_no: item.delivery_no
          }
        });
      }
      // 避難情報
      if (item.delivery_ca === "LE") {
        this.$router.push({
          name: "lalert-evacuation-view",
          params: {
            delivery_no: item.delivery_no
          }
        });
      }
    },

    // 編集画面の権限があるかチェック
    hasEditAuth(deliveryCa) {
      let editScreenId = "";
      if (deliveryCa === "LI") {
        // お知らせ
        editScreenId = ScreenId.SF2103;
      } else if (deliveryCa === "LE") {
        // 避難情報
        editScreenId = ScreenId.SF2105;
      }
      const editAuth = this.$screenAuthority.find(
        auth => auth.screen_id === editScreenId
      );
      if (editAuth) {
        const screenCrud = ScreenCrud.factory(editAuth.screen_crud);
        return screenCrud.isOperation();
      } else {
        return false;
      }
    },

    // 一覧の削除ボタン押下
    async deleteItem(item) {
      let message = "この広報内容を削除してもよろしいですか？";
      if (!(await this.deleteConfirm(message))) {
        return false;
      }
      message = "削除した場合には元に戻せません。本当によろしいですか？";
      if (!(await this.deleteConfirm(message))) {
        return false;
      }

      // 枝番を除外した配信番号
      const DELIVERY_NO = item.delivery_no.split("-")[0];

      // 削除
      const payload = {
        disaster_no: item.disaster_no,
        delivery_no: DELIVERY_NO,
        delivery_no_sub: item.delivery_no_sub,
        hash: item.hash
      };

      // 画面上部に表示されるメッセージ一を消す
      this.clearMessage();
      await lalertEvaInfoRepository
        .delete(this.screenId, payload)
        .then(response => {
          this.handleSuccess(response);
        })
        .catch(e => {
          this.handleUpdateError(e);
        });

      // 一覧取得
      this.overlay = true;
      await lalertEvaInfoRepository
        .list(this.screenId)
        .then(response => {
          // LAlertの一覧取得
          this.lalertEvaInfoList = this.changeDeliveryNoArrayFormat(
            response.data.results
          );
        })
        .catch(e => {
          this.handleError(e, this.screenId, "aggregation-menu");
        });
      this.overlay = false;
    },

    // 一覧の再送信ボタン押下
    async resendItem(item) {
      let message = "配信に失敗した情報を、再送信します。\nよろしいですか？";
      if (!(await this.$refs.confirm.open(message, "送信"))) {
        return false;
      }

      // 枝番を除外した配信番号
      const DELIVERY_NO = item.delivery_no.split("-")[0];

      // 再送信
      const payload = {
        disaster_no: item.disaster_no,
        delivery_no: DELIVERY_NO,
        delivery_no_sub: item.delivery_no_sub,
        delivery_status: "2", // 再送信コード(入力用)
        hash: item.hash
      };

      this.clearMessage();
      await lalertEvaInfoRepository
        .resend(this.screenId, payload)
        .then(response => {
          this.handleSuccess(response);
        })
        .catch(e => {
          this.handleUpdateError(e);
        });

      // 一覧取得
      this.overlay = true;
      await lalertEvaInfoRepository
        .list(this.screenId)
        .then(response => {
          // LAlertの一覧取得
          this.lalertEvaInfoList = this.changeDeliveryNoArrayFormat(
            response.data.results
          );
        })
        .catch(e => {
          this.handleError(e, this.screenId, "aggregation-menu");
        });
      this.overlay = false;
    },

    //削除ポップアップ
    deleteConfirm(message) {
      return this.$refs.confirm.open(message, "削除");
    },

    //配信番号のフォーマット変更 (配信番号-配信番号枝番)
    changeDeliveryNoArrayFormat(value) {
      // 0件処理
      if (!value.length) {
        return value;
      }
      // フォーマット変更
      return value.map(ele => {
        ele.delivery_no = `${ele.delivery_no}-${ele.delivery_no_sub}`;
        return ele;
      });
    },

    //フィルター（配信番号）
    deliveryNoFilter(value) {
      if (!this.deliveryNoFilterValue) {
        return true;
      }
      return value.includes(this.deliveryNoFilterValue);
    },

    //フィルター（配信種別）
    deliveryCaFilter(value) {
      this.resetPage();
      if (
        !this.deliveryCaFilterValue ||
        this.deliveryCaFilterValue.length === 0
      ) {
        return true;
      }
      return this.deliveryCaFilterValue.includes(value + "");
    },

    //フィルター（発令解除区分）
    declareFlgFilter(value) {
      this.resetPage();
      if (
        this.declareFlgFilterValue === undefined ||
        this.declareFlgFilterValue === null ||
        this.declareFlgFilterValue.length === 0
      ) {
        return true;
      }
      // 空白行は検索条件にかからないようにする
      if (value == "") {
        return false;
      }
      return this.declareFlgFilterValue.includes(value + "");
    },

    //フィルター（発令区分）
    declareClsFilter(value) {
      this.resetPage();
      if (
        !this.declareClsFilterValue ||
        this.declareClsFilterValue.length === 0
      ) {
        return true;
      }
      // 空白行は検索条件にかからないようにする
      if (!value) {
        return false;
      }
      return this.declareClsFilterValue.includes(value + "");
    },

    //フィルター（配信日時）
    deliveryDateFilter(value) {
      this.resetPage();
      if (!this.deliveryStartDateValue && !this.deliveryEndDateValue) {
        return true;
      }
      // 選択した開始時間
      const formattedStartDate = this.$moment(
        this.deliveryStartDateValue,
        "YYYY/MM/DD HH:mm:ss"
      );
      // 選択した終了時間(59分追加)
      const formattedendDate = this.$moment(
        this.deliveryEndDateValue,
        "YYYY/MM/DD HH:mm:ss"
      ).add(59, "minutes");
      // 開始時間の00分が含まれる
      if (
        formattedStartDate.isValid() &&
        new Date(value) < formattedStartDate.toDate()
      ) {
        return false;
      }
      // 終了時間の59分まで含める
      if (
        formattedendDate.isValid() &&
        new Date(value) > formattedendDate.toDate()
      ) {
        return false;
      }
      return true;
    },

    //フィルター（災害名称）
    disasterNameFilter(value) {
      this.resetPage();
      if (!this.disasterNameFilterValue) {
        return true;
      }
      return value === this.disasterNameFilterValue;
    },

    //フィルター（緊急事態区分）
    emergencyClassFilter(value) {
      this.resetPage();
      if (
        !this.emergencyClassFilterValue ||
        this.emergencyClassFilterValue.length === 0
      ) {
        return true;
      }
      return this.emergencyClassFilterValue.includes(value);
    },

    //ソート（緊急事態区分）
    emergencyClassSorter(a, b) {
      if (a !== b) {
        // 配列の格納順でソート
        const sortList = [
          EmergencyClass.NL,
          EmergencyClass.AL,
          EmergencyClass.SE,
          EmergencyClass.GE,
          EmergencyClass.FN
        ];
        const indexA = sortList.indexOf(a);
        const indexB = sortList.indexOf(b);
        if (indexA > indexB) {
          return 1;
        } else {
          return -1;
        }
      }
      return 0;
    },

    //項目リスト（緊急事態区分）
    emergencyClassItems(item) {
      const EMERGENCY_NAME = EmergencyClass.factory(
        item.emergencyClass
      ).toName();
      return EMERGENCY_NAME ? EMERGENCY_NAME : "緊急事態なし";
    },

    // フィルター（公開希望終了日時）
    publishDateFilter(value) {
      this.resetPage();
      // 画面初期化の時フィルターされるのを防止
      if (!this.publishStartDateValue && !this.publishEndDateValue) {
        return true;
      }
      // 空白行は検索条件にかからないようにする
      if (value == "") {
        return false;
      }
      // 選択した開始時間
      const formattedStartDate = this.$moment(
        this.publishStartDateValue,
        "YYYY/MM/DD HH:mm:ss"
      );
      // 選択した終了時間(59分追加)
      const formattedendDate = this.$moment(
        this.publishEndDateValue,
        "YYYY/MM/DD HH:mm:ss"
      ).add(59, "minutes");
      // 開始時間の00分が含まれる
      if (
        formattedStartDate.isValid() &&
        new Date(value) < formattedStartDate.toDate()
      ) {
        return false;
      }
      // 終了時間の59分まで含める
      if (
        formattedendDate.isValid() &&
        new Date(value) > formattedendDate.toDate()
      ) {
        return false;
      }
      return true;
    },

    //フィルター（配信状況）
    deliveryStatusFilter(value) {
      this.resetPage();
      if (
        !this.deliveryStatusFilterValue ||
        this.deliveryStatusFilterValue.length === 0
      ) {
        return true;
      }
      return this.deliveryStatusFilterValue.includes(value + "");
    },

    //フィルター（配信区分）
    deliveryClsFilter(value) {
      this.resetPage();
      if (
        !this.deliveryClsFilterValue ||
        this.deliveryClsFilterValue.length === 0
      ) {
        return true;
      }
      return this.deliveryClsFilterValue.includes(value + "");
    },

    // 配信状況が失敗の場合、TOOLTIPで市町村を表示する
    addToolTipDeliveryStatus(item) {
      const MUNICIP_CODE_LIST = item.dests?.map(e => e.municip_code);
      // 配信失敗先がなければ表示しない
      if (!MUNICIP_CODE_LIST) {
        return;
      }
      const MUNICIP_NAME_LIST = this.municipalities
        .filter(municipality =>
          MUNICIP_CODE_LIST.includes(municipality.municip_code)
        )
        .map(e => e.municip_name)
        .join("、");
      return `配信失敗：${MUNICIP_NAME_LIST}`;
    },

    // 配信管理ボタンの活性・非活性制御
    checkDeliveryBtn(item) {
      // 画面の参照権限のみ場合、ボタン非活性
      if (this.listFlag) {
        return true;
      }
      // 続報FLAGチェック
      if (item.follow_up_flg == "0") {
        return true;
      }
      // 配信状況が配信済み状態以外非活性
      if (item.delivery_status != "2") {
        return true;
      }
      // データの権限チェック(authCheck)
      if (!this.hasUpdateAuthorityByItem(item)) {
        return true;
      }

      return false;
    },

    // 日付表示形式編集
    formatDatetime(datetime) {
      if (!datetime) {
        return "";
      }
      const formattedDatetime = this.$moment(datetime, "YYYYMMDDHHmmssSSS");
      if (!formattedDatetime.isValid()) {
        return "";
      }
      return formattedDatetime.format("YYYY/MM/DD HH:mm");
    },

    // 1ページ目に戻す処理
    resetPage() {
      if (this.$refs.lalertEvaInfoTable) {
        this.$refs.lalertEvaInfoTable.resetPage();
      }
    },

    // 最新の情報に更新ボタン押下時
    async reload() {
      this.overlay = true;
      await lalertEvaInfoRepository
        .list(this.screenId)
        .then(response => {
          // LAlertの一覧取得
          this.lalertEvaInfoList = this.changeDeliveryNoArrayFormat(
            response.data.results
          );
        })
        .catch(e => {
          this.handleGetError(e);
        });
      this.overlay = false;
    },
    /**
     * カスタムSORT
     * 空白と0を含むセルが存在する時、セルのSORT結果に異常があるため作成
     * ヘッダーの昇順降順選択によってa,bの値が変わる
     */
    emptyStringSorter(a, b) {
      if (a !== b) {
        // 並び順はユニコード基準にに作成（昇順の時下記の並び順になります）
        // 空白 → U+00A0
        // 9 → U+0039
        // 0 → U+0030
        const sortList = ["", "9", "0"];
        const indexA = sortList.indexOf(a);
        const indexB = sortList.indexOf(b);
        // sortListによる昇順・降順切り分け
        if (indexA > indexB) {
          return 1;
        } else {
          return -1;
        }
      }
      return 0;
    }
  }
};

//セレクトボックスに使われる選択項目リスト
const WHICH_CHOOSE = Object.freeze([
  // 0.配信種別
  [
    {
      value: "LI",
      text: "お知らせ"
    },
    {
      value: "LE",
      text: "避難情報"
    }
  ],
  // 1.発令解除区分
  [
    {
      value: "0",
      text: "発令"
    },
    {
      value: "9",
      text: "解除"
    }
  ],
  // 2.発令区分
  [
    {
      value: "3",
      text: "高齢者等避難"
    },
    {
      value: "4",
      text: "避難指示"
    },
    {
      value: "6",
      text: "警戒区域情報"
    },
    {
      value: "5",
      text: "緊急安全確保"
    }
  ],
  // 3.配信状況
  [
    {
      value: "0",
      text: "未配信"
    },
    {
      value: "1",
      text: "配信中"
    },
    {
      value: "2",
      text: "配信済"
    },
    {
      value: "3",
      text: "配信失敗"
    }
  ],
  // 4.配信区分
  [
    {
      value: "NE",
      text: "新規広報"
    },
    {
      value: "FU",
      text: "続報"
    },
    {
      value: "CO",
      text: "訂正報"
    },
    {
      value: "CA",
      text: "取消報"
    }
  ]
]);
</script>
<style>
/* datetime-pickerの年月日コンポネント位置調整 */
.datetime-without-min .year-input {
  max-width: 60%;
  flex: 100%;
}
/* datetime-pickerの時間コンポネント位置調整 */
.datetime-without-min .hour-input {
  max-width: 40%;
  flex: 100%;
}
</style>
